module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7r2r5n-fedf33dced0902388e597480872e6960.svg";